module.exports = __webpack_public_path__ + "static/david-6bad0b9fd575a1046a317278fd95ab46.png";